import { LoquixActionEdit } from './loquix-action-edit.js';

if (!customElements.get('loquix-action-edit')) {
  customElements.define('loquix-action-edit', LoquixActionEdit);
}
